 <template>
	<section class="select_pt_module">
		<section class="choose_specification">
			<section class="choose_icon_container">
			
				<div class='exchange-title'>
					<span>點數兌換&nbsp;<div class="no_mobile">Point Redeem</div></span>
				</div>
				<div class="stepper">
					<div class="button-primary sub" @click.stop='modify("-")' @click="removePointOutCart(products.category_id, products.item_id, products.specproducts[0].product_id, products.specproducts[0].name, (isOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price),products.specproducts[0].pv,products.specproducts[0].pt, '', products.specproducts[0].packing_fee, products.specproducts[0].sku_id,products.sku, products.specproducts[0].stock)">
						<Icon type="md-remove"  />
					</div>
					<span class="number">{{productPointNum}}</span>
					<div class="button-primary add" @click.stop='modify("+")' @click="addPointToCart(products.category_id, products.item_id, products.specproducts[0].product_id, products.specproducts[0].name, (isOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price),products.specproducts[0].pv,products.specproducts[0].pt, '', products.specproducts[0].packing_fee, products.specproducts[0].sku_id,products.sku, products.specproducts[0].stock, $event)">
						<Icon type="md-add" />
					</div>
					<span class="pt">PT:&nbsp;{{products.specproducts[0].pt*productPointNum}}</span>
				</div>

			</section>
		</section>
		<section>
			<transition name="fade">
				<div class="specs_cover" @click="showChoosePTList" v-if="showPTChange"></div>
			</transition>
			<transition name="fadeBounce">
				<div class="specs_list" v-if="showPTChange">
					<header class="specs_list_header">
						<h4 class="ellipsis">{{choosedProducts.name}}</h4>
						<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" version="1.1" class="specs_cancel" @click="showChoosePTList">
							<line x1="0" y1="0" x2="16" y2="16" stroke="#666" stroke-width="1.2" />
							<line x1="0" y1="16" x2="16" y2="0" stroke="#666" stroke-width="1.2" />
						</svg>
					</header>
					<section class="specs_details">
						<!-- <h5 class="specs_details_title">{{choosedProducts.name}}</h5>-->
						<h5 class="specs_details_title">兌換個數(Redeem Qty)：</h5>
						<ul>
							<section class="cart_button">
								<transition name="showReduce">
									<span v-if="productPointNum" @click="removePointOutCart(products.category_id, products.item_id, products.specproducts[0].product_id, products.specproducts[0].name, (isOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price),products.specproducts[0].pv,products.specproducts[0].pt, '', products.specproducts[0].packing_fee, products.specproducts[0].sku_id,products.sku, products.specproducts[0].stock)">
										<img class="remove_icon" src="@/assets/order/remove.png">

									</span>
								</transition>
								<transition name="fade">
									<span class="cart_num" v-if="productPointNum">
										{{productPointNum}}
										<!-- <input readonly v-model="productPointNum" @keyup="editPointCart(products.category_id, products.item_id, products.specproducts[0].product_id, products.specproducts[0].name, (isOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price),products.specproducts[0].pv,products.specproducts[0].pt, '', products.specproducts[0].packing_fee, products.specproducts[0].sku_id,products.sku, products.specproducts[0].stock, $event)"> -->
									</span>
								</transition>
								<img class="add_icon" src="@/assets/order/add.png" @click="addPointToCart(products.category_id, products.item_id, products.specproducts[0].product_id, products.specproducts[0].name, (isOriginalPrice?products.specproducts[0].original_price:products.specproducts[0].price),products.specproducts[0].pv,products.specproducts[0].pt, '', products.specproducts[0].packing_fee, products.specproducts[0].sku_id,products.sku, products.specproducts[0].stock, $event)">

							</section>
						</ul>
					</section>
					<!-- <section class="specs_details">
						<h5 class="specs_details_title" style="float:none;">兌換數量(Redeem Qty): {{products.num-productPointNum}}</h5>
					</section> -->
					<section class="specs_details">
						<h5 class="specs_details_title" style="float:none;">總購買數量(Total Buy Qty): {{productNum}}</h5>
					</section>
					<!-- <section class="specs_details">
						<h5 class="specs_details_title" style="float:none;">點數餘額(Point Balance):{{poinBalance}}</h5>
					</section> -->
					<footer class="specs_footer">
						<div class="specs_price">
							<!-- <span>兌換點數(Redeem Point)：</span>
							<span>{{products.specproducts[0].pt * productPointNum}}</span> -->
						</div>
						<div class="specs_addto_cart" @click="showChoosePTList">確認(Confirm)</div>
					</footer>
				</div>
			</transition>
		</section>
	</section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
	promoteMethods,
	cartInfoMethods,
	userInfoOrderMethods,
} from "@/components/common/mixin";
export default {
	data() {
		return {
			showMoveDot: [], //控製下落的小圓點顯示隱藏
			choosedProducts: null, //當前選中視頻數據
			showPTChange: false, //控製顯示PT兌換小窗口
		};
	},
	mounted() {},
	computed: {
		...mapState({
			userInfo: (state) => state.common.wechatUserInfo,
			forCustomer: (state) => state.order.forCustomer,
			cartInfo: (state) => state.order.cartInfo,
			promote: (state) => state.order.promote,
		}),
		/**
		 * 監聽cartList變化，更新當前商鋪的購物車信息shopCart，同時返回一個新的對象
		 */

		btnName: function () {
			let name = '點數兌換<div class="no_mobile">Point Redeem</div>';
			if (this.productPointNum > 0) {
				name =
					"兌換 " +
					this.productPointNum +
					' 個 <div class="no_mobile">Redeem Qty</div>';
			}
			return name;
		},
		//shopCart變化的時候重新計算當前商品的數量
		productNum: function () {
			let sku = this.products.sku;
			let sc = this.shopCart;
			let num = 0;
			let item = sc.filter((u) => u.sku == sku);
			if (item[0]) {
				num += item[0].num;
			}
			return num;
		},
		TotalProductPV: function () {
			let total_pv = this.cartPrice.total_pv || 0.0;
			return total_pv;
		},
		total_change_point: function () {
			let result = this.cartPrice.total_change_point || 0.0;
			return result;
		},
		//shopCart變化的時候重新計算當前商品的數量
		productPointNum: function () {
			let sku = this.products.sku;
			let sc = this.shopCart;
			let item = sc.filter((u) => u.sku == sku);
			let num = 0;
			if (item[0]) {
				num += item[0].point / item[0].pt;
			}
			return num;
		},
	},
	mixins: [userInfoOrderMethods, cartInfoMethods, promoteMethods],
	props: ["products", "poinBalance"],
	methods: {
		...mapMutations(["ADD_CART", "REDUCE_CART", "EDIT_CART1"]),
		//移出購物車
		removePointOutCart(
			category_id,
			item_id,
			product_id,
			name,
			price,
			pv,
			pt,
			specs,
			packing_fee,
			sku_id,
			sku,
			stock
		) {
			let ar_value = 0;
			let num = 0;
			let pn = this.products.num;
			let ppn = this.productPointNum;
			if (ppn > 0) {
				num = pn; // + 1;
				let amount = price * (pn - ppn + 1);
				let point = (ppn - 1) * pt;
				//console.log(point);
				//console.log(ppn);
				//console.log(pt);
				console.log(point);
				this.EDIT_CART1({ sku, num, amount, point, canCart: true });
				//this.EDIT_CART({category_id, item_id, product_id, name, price,pv,pt, specs, packing_fee, sku_id,sku, stock,num,amount,point});
				//let elLeft = event.target.getBoundingClientRect().left;
				//let elBottom = event.target.getBoundingClientRect().bottom;
				//this.showMoveDot.push(true);
				//this.$emit('showMoveDot', this.showMoveDot, elLeft, elBottom);
			}
		},
		//加入購物車，計算按鈕位置。
		addPointToCart(
			category_id,
			item_id,
			product_id,
			name,
			price,
			pv,
			pt,
			specs,
			packing_fee,
			sku_id,
			sku,
			stock,
			event
		) {
			let ar_value = 0;
			let num = 0;
			let pn = this.products.num;
			let ppn = this.productPointNum;

			// console.log(this.poinBalance);
			// console.log(this.total_change_point);

			if (pn > 0 && ppn < pn) {
				num = pn; // - 1;
				let amount = (pn - ppn - 1) * price;
				let point = (ppn + 1) * pt;
				let newTotalProductPV = this.TotalProductPV - pv;
				if (this.total_change_point + pt > this.poinBalance) {
					this.showTips("回饋點數不足<br>points is insufficient");
					return;
				}
				if (true) {
					this.EDIT_CART1({ sku, num, amount, point, canCart: true });
					//this.IsPromoteTip(sku,category_id, item_id, product_id)
				} else {
					this.showTips(
						"親愛的顧客，非常抱歉，兌換回饋點數不能超過訂單總産品點數的兩倍<br>Sorry, redeemed points cannot exceed twice than the total PV of order"
					);
					return;
				}
			} else {
				this.showTips("親愛的顧客，非常抱歉，産品數量不足");
			}
			//console.log(category_id+ item_id+ product_id+ name+price+ specs+ packing_fee+ sku_id+ stock+ event)
		},
		//加入購物車，計算按鈕位置。
		editPointCart(
			category_id,
			item_id,
			product_id,
			name,
			price,
			pv,
			pt,
			specs,
			packing_fee,
			sku_id,
			sku,
			stock,
			event
		) {
			let pointNum = Number(event.target.value);
			if (isNaN(pointNum)) {
				pointNum = 1;
				event.target.value = "1";
			}
			let df = event.target.value;
			if (!/^[0-9]+$/.test(df)) {
				pointNum = 1;
				event.target.value = "1";
			}
			let ar_value = 0;
			let num = 0;
			let pn = this.productNum;
			let ppn = this.productPointNum;
			if (pn > 0) {
				num = pn; // - pointNum;
				let amount = price * (pn - pointNum);
				let point = pointNum * pt;
				if (this.total_change_point + point > this.poinBalance) {
					this.showTips("回饋點數不足");
					event.target.value = "1";
					return;
				}
				this.EDIT_CART1({ sku, num, amount, point });
				//let elLeft = event.target.getBoundingClientRect().left;
				//let elBottom = event.target.getBoundingClientRect().bottom;
				//this.showMoveDot.push(true);
				//this.$emit('showMoveDot', this.showMoveDot, elLeft, elBottom);
			}
		},

		showChoosePTList(products) {
			if (products) {
				this.choosedProducts = products;
			}
			this.showPTChange = !this.showPTChange;
		},
		//點擊多規格商品的減按鈕，彈出提示
		showReduceTip() {
			this.$emit("showReduceTip");
		},
		showTips(msg) {
			this.$Toast.show(msg, { duration: 2000 });
		},
	},
};
</script>

<style lang="scss" scoped>
@import "@/style/mixin";
.exchange-title {
	margin-bottom: 5px;
	position: relative;
	//right: 5px;
	color: white;
	@include fontSize($font-size-14);
}
.select_pt_module {
	display: inline-block;
	//padding: 4.69px 0;
	position: absolute;
	top: 20%;
	//bottom: 0;
	right: 0;
	float: right;
	margin-top: 0px;
	.add_icon {
		position: relative;
		z-index: 999;
		margin: 5.86px;
	}
	.remove_icon {
		position: relative;
		margin-top: 5.86px;
	}
	.cart_button {
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	img {
		@include wh(21.09px, 21.09px);
		fill: $theme-color;
	}
	.specs_reduce_icon {
		fill: #999;
	}
	.cart_num {
		@include sc(15.23px, #666);
		min-width: 23.44px;
		text-align: center;
		font-family: Helvetica Neue, Tahoma;
		input {
			width: 35.16px;
			border: 1px #ddd solid;
			padding: 2.34px;
			margin: 4.69px;
		}
	}
	.choose_specification {
		.choose_icon_container {
			position: relative;
			//top: -5px;
			background-color: $green;
			min-width: 2rem;
			display: inline-block;
			border-radius: 0.4rem;
			//padding: 0px px;
			padding-top: 0.1rem;
			padding-bottom: 0.1rem;
			.show_chooselist {
				display: inline-block;
				cursor: pointer;
				color: white;
				//@include sc(13px, #fff);
				//padding: 8px;
				//background-color: white;
				//border-radius: 15px;
				//border: 1px solid white;
			}
		}
	}
}

.stepper {
	position: relative;
	left: 0.4rem;
	display: flex;
	float: left;
	.sub,
	.add {
		background-color: white;
		width: 25px;
		text-align: center;
		margin: 0 8px;
		height: 23px;
		line-height: 23px;
		border-radius: 5px;
		//padding-bottom: 5px;
		cursor: pointer;
		// color: #222;
		// font-weight: 800;

		//border-radius: 5px;
	}
	.number {
		color: white;
		font-weight: 800;
		line-height: 25px;
	}
	.pt {
		color: white;
		font-weight: 800;
		line-height: 25px;
	}
}

.showReduce-enter-active,
.showReduce-leave-active {
	transition: all 0.3s ease-out;
}
.showReduce-enter,
.showReduce-leave-active {
	opacity: 0;
	transform: translateX(23.44px);
}
.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s;
}
.fade-enter,
.fade-leave-active {
	opacity: 0;
}
.fadeBounce-enter-active,
.fadeBounce-leave-active {
	transition: all 0.3s;
}
.fadeBounce-enter,
.fadeBounce-leave-active {
	opacity: 0;
	transform: scale(0.7);
}

.specs_cover {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.4);
	z-index: 20000;
}
.specs_list {
	position: fixed;
	top: 35%;
	left: calc(50% - 200px);
	width: 400px;
	background-color: #fff;
	z-index: 20001;
	border: 1px;
	border-radius: 4.69px;
	.specs_list_header {
		h4 {
			@include sc(16.41px, #222);
			font-weight: normal;
			text-align: center;
			padding: 11.72px;
		}
		.specs_cancel {
			position: absolute;
			right: 11.72px;
			top: 11.72px;
		}
	}
	.specs_details {
		padding: 11.72px;
		.specs_details_title {
			@include sc(14.06px, #666);
			margin: 5.86px 0 0 2.34px;
			float: left;
		}
		ul {
			display: flex;
			flex-wrap: wrap;
			padding: 0px 0;
			li {
				font-size: 14.06px;
				padding: 7.03px 11.72px;
				border: 0.59px solid #ddd;
				border-radius: 4.69px;
				margin-right: 11.72px;
			}
			.specs_activity {
				border-color: #3199e8;
				color: #3199e8;
			}
		}
	}
	.specs_footer {
		@include fj;
		align-items: center;
		background-color: #f9f9f9;
		padding: 11.72px;
		border: 1px;
		border-bottom-left-radius: 4.69px;
		border-bottom-right-radius: 4.69px;
		.specs_price {
			span {
				color: #ff6000;
			}
			span:nth-of-type(1) {
				font-size: 11.72px;
			}
			span:nth-of-type(2) {
				font-size: 18.75px;
				font-weight: bold;
				font-family: Helvetica Neue, Tahoma;
			}
		}
		.specs_addto_cart {
			@include wh(120.75px, 30.47px);
			background-color: $theme-color;
			border: 1px;
			cursor: pointer;
			border-radius: 3.52px;
			@include sc(14.06px, #fff);
			text-align: center;
			line-height: 30.47px;
		}
	}
}
.no_mobile {
	display: inline-block;
}
@media (max-width: 768px) {
	.exchange-title{
		margin-bottom: 0;
	}
	.stepper {
		display: flex;
		float: left;
		.sub,
		.add {
			line-height: inherit;
			width: 20px;
			padding: 0;
			margin: 0 8px;
			height: 20px;
			
		}
		.number {
			line-height: inherit;
		}
		.pt {
			line-height: inherit;
			@include fontSize($font-size-14);
			display: none;
		}
	}
	.select_pt_module {
		.choose_specification {
			.choose_icon_container {
				padding: 5px 15px;
				//margin-bottom: 20px;
			}
		}
	}

	.no_mobile {
		display: none;
	}
	.specs_list {
		width: 95%;
		left: calc(50% - 7.6rem);
		.specs_list_header {
			h4 {
				font-size: 0.6rem;
			}
		}
		.specs_details {
			.specs_details_title {
				font-size: 0.55rem;
				text-align: left;
			}
		}
	}
}
</style>